"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("../styles");
const styles = styles_1.createStyles({
    container: {
        display: 'grid',
        width: '100%',
    },
    fill: {
        width: '100%',
        height: '100%',
    },
    overflowing: {
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        willChange: 'scroll-position',
        backfaceVisibility: 'hidden',
    },
});
exports.decorate = styles_1.withStyles(styles, { injectTheme: true });
